module.exports = __webpack_public_path__ + "components/t-shirt-comp/static/La-Graviere-935bfcfb61ab02c2696a63533495d1c0.jpg";